// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__jzVS4","footer":"ModalInfo_footer__11M8x"};